<script setup lang="ts">
import { Environment } from '@tresjs/cientos'

const { width } = useWindowSize()

defineProps<{
  data: WorkRecord[] | null
  enabled: boolean
}>()

const options = {
  shadows: false, // false for performance
  alpha: true,
  clearColor: 0xffffff,
  powerPreference: 'high-performance',
  antialias: true,
  stencil: false,
  depth: false,
  windowSize: false
}

const isUnveiled = ref(false)

const zPosition = computed(() => {
  if (width.value <= 420) {
    return 40
  } else if (width.value <= 520) {
    return 34
  } else {
    return 30
  }
})

onMounted(() => {
  isUnveiled.value = true
})
</script>

<template>
  <div class="bg-red absolute left-0 top-0 h-[700px] w-full md:h-[1400px]">
    <TresCanvas v-if="enabled" v-bind="options" class="absolute left-0 top-0 h-[2000px] w-full">
      <TresAmbientLight :intensity="1" />
      <TresDirectionalLight :intensity="1" :position="[25, 25, 0]" />
      <TresDirectionalLight :intensity="5" :position="[-25, 25, 0]" color="#6B59B1" />
      <TresPerspectiveCamera :position="[0, 0, zPosition]" :look-at="[0, 0, 0]" />
      <CanvasRenderer />
      <Suspense>
        <CanvasWorkGrid :data="data" />
      </Suspense>
      <Suspense>
        <Environment preset="sunset" />
      </Suspense>
      <!--<Stats /> -->
    </TresCanvas>
    <CanvasFallback v-else />
  </div>
</template>
